import React from 'react';
import { ScrollableOverlay } from '../../scrollable-overlay/scrollable-overlay';
import { classes, style } from 'typestyle';
import { spacing } from '../../../theme/spacing';
import { rebrand } from '../../../theme/color';
import overlayStyles, { ScrollableOverlayBodyStyle } from '../../../styles/scrollable-overlay';
import { important, px } from 'csx';
import { mediaSmallTablet } from '../utilities/mediaQueries';

interface ClaimsManagedModalModalProps {
  show: boolean;
  onRequestClose(): void;
}

export const ClaimsManagedModal: React.FC<ClaimsManagedModalModalProps> = ({ show, onRequestClose }) => {
  return (
    <ScrollableOverlay className={styles.wrapper} show={show} onRequestClose={onRequestClose}>
      <div className={overlayStyles.header} style={{ padding: '0 0 24px' }}>
        <h3 className={classes(styles.heading, overlayStyles.title)}>Claims-managed license</h3>
      </div>
      <div className={styles.body}>
        <p className={styles.description}>
          A third party are involved in releasing the claim for this track; the claims will be sorted within 4 hours on
          a weekday and within 48 hours at the weekend.
        </p>
      </div>
    </ScrollableOverlay>
  );
};

const styles = {
  description: style({
    fontSize: '16px',
    marginBottom: spacing.LARGE,
  }),
  body: style(ScrollableOverlayBodyStyle, {
    padding: '1.5rem 0 0',
    borderTop: `1px solid ${rebrand.light1.toString()}`,
    textAlign: 'center',
    $nest: {
      '& > p': {
        margin: '0 0 1.5rem',
        textAlign: 'left',
        lineHeight: px(24),
      },
    },
  }),
  wrapper: style(
    mediaSmallTablet({
      padding: important('24px'),
    }),
    { display: 'block', maxWidth: px(440) }
  ),
  heading: style({
    fontSize: px(24),
  }),
};
